module.exports = __webpack_public_path__ + "img/404.8fe9fb8d.jpg";